// Generated by GitHub Copilot
import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import msalInstance, { initializeMsal } from './auth/msalInstance';
import SessionExpiry from './components/auth/SessionExpiry';
import { ssoEnabled } from './auth/authConfig';
import { initializeClarity } from './clarity';

// Prefer runtime config.js value; fallback to .env for local development.
const runtimeClarityProjectId =
  typeof window !== 'undefined'
    ? window.__APP_CONFIG__?.REACT_APP_CLARITY_PROJECT_ID
    : '';
const clarityProjectId =
  typeof runtimeClarityProjectId === 'string' &&
  runtimeClarityProjectId.trim() &&
  !runtimeClarityProjectId.startsWith('#{')
    ? runtimeClarityProjectId.trim()
    : process.env.REACT_APP_CLARITY_PROJECT_ID;

initializeClarity(clarityProjectId);

if (ssoEnabled) {
  /**
   * Initialise MSAL (handles any pending redirect response) before mounting
   * React. This ensures tokens are in the cache when the app first renders,
   * preventing a flash of the unauthenticated state for returning users.
   */
  initializeMsal().then(() => {
     const account = msalInstance.getActiveAccount();
     
      if (account && window.clarity) {
        window.clarity(
          'identify',
          account.homeAccountId,
          undefined,
          undefined,
          account.name
        );
      }
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <SessionExpiry />
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
} else {
  // SSO disabled — skip MSAL entirely; do not mount <MsalProvider>.
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

